/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateWall = /* GraphQL */ `
  subscription OnCreateWall {
    onCreateWall {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onUpdateWall = /* GraphQL */ `
  subscription OnUpdateWall {
    onUpdateWall {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onDeleteWall = /* GraphQL */ `
  subscription OnDeleteWall {
    onDeleteWall {
      id
      status
      senderId
      senderName
      occasion
      layout
      config
      greetingType
      passcode
      createdAt
      cards {
        items {
          id
          text
          cardName
          senderId
          senderName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      recipients {
        items {
          id
          recipientId
          recipientName
          wallID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const onCreateWallCard = /* GraphQL */ `
  subscription OnCreateWallCard {
    onCreateWallCard {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onUpdateWallCard = /* GraphQL */ `
  subscription OnUpdateWallCard {
    onUpdateWallCard {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onDeleteWallCard = /* GraphQL */ `
  subscription OnDeleteWallCard {
    onDeleteWallCard {
      id
      text
      cardName
      senderId
      senderName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onCreateWallRecipient = /* GraphQL */ `
  subscription OnCreateWallRecipient {
    onCreateWallRecipient {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onUpdateWallRecipient = /* GraphQL */ `
  subscription OnUpdateWallRecipient {
    onUpdateWallRecipient {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
export const onDeleteWallRecipient = /* GraphQL */ `
  subscription OnDeleteWallRecipient {
    onDeleteWallRecipient {
      id
      recipientId
      recipientName
      wallID
      createdAt
      wall {
        id
        status
        senderId
        senderName
        occasion
        layout
        config
        greetingType
        passcode
        createdAt
        cards {
          nextToken
        }
        recipients {
          nextToken
        }
        updatedAt
      }
      updatedAt
    }
  }
`;
